import axiosInstance from "../../axios";

export type PlatformDto = {
  title: string;
  value: string;
  logoUrl?: string;
};

export const Platforms = {
  getPlatformsDropdown: async (): Promise<PlatformDto[]> => {
    const { data } = await axiosInstance.get("/statistics/platforms");
    return data.data;
  },
};
